import storage from '@/utils/storage';

export const BackIcon = ({ onClick, className }: { onClick: () => void; className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Group 13672"
    width="42"
    height="42"
    viewBox="0 0 42 42"
    onClick={onClick}
    className={className}
  >
    <g data-name="Group 13670">
      <path
        data-name="Rectangle 10128"
        style={{
          fill: 'none',
        }}
        d="M0 0h42v42H0z"
      />
      <path
        data-name="Rectangle 10129"
        transform="translate(5 5)"
        style={{
          fill: '#fff',
        }}
        d="M0 0h34v34H0z"
      />
    </g>
    <g
      data-name="Group 13671"
      style={{
        opacity: '.996',
      }}
    >
      <path
        data-name="Path 20013"
        d="M226.2 115.927a1.911 1.911 0 1 0 2.7-2.7l-7.344-7.343h21.265a1.911 1.911 0 0 0 0-3.822h-21.266l7.345-7.345a1.911 1.911 0 0 0-2.7-2.7l-10.6 10.601a1.911 1.911 0 0 0 0 2.7z"
        transform="translate(-208.36 -82.426)"
        style={{
          fill: storage.getItem('primaryColor') ?? '',
        }}
      />
    </g>
  </svg>
);
